import injectSheet from 'react-jss';

import {rem} from '-/styles/utils';

const styles = () => ({
    root: {
        textAlign: 'center',
        maxWidth: rem(400),
        margin: 'auto auto',
        padding: rem(20)
    },
    info: {
        fontSize: '2em',
        fontWeight: 'bold'
    }
});

const NotAccepting = props => {
    const {classes = {}} = props;
    
    return (
        <div className={classes.root}>
            <div>
                <p className={classes.info}>We are not currently accepting credit applications at this time.</p>
            </div>
        </div>
    );
};

export default injectSheet(styles)(NotAccepting);
